import { Button, Form, Modal } from 'shared/components/ui';
import React, { useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import { derivadoresAPI } from '../../../../core/api/api';

const NuevoDerivadorModal = ({ show, onHide, onDerivadorCreado, localidades }) => {
  const [formData, setFormData] = useState({
    nombre: '',
    especialidad: '',
    idLocalidad: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.nombre.trim()) {
      setError('El nombre es requerido');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      
      const response = await derivadoresAPI.agregarDerivador({
        nombre: formData.nombre.trim(),
        especialidad: formData.especialidad.trim() || null,
        idLocalidad: formData.idLocalidad || null,
        usrAlta: user.username || 'usuario'
      });

      if (onDerivadorCreado) {
        await onDerivadorCreado(response.data.idDerivador);
      }

      setFormData({ nombre: '', especialidad: '', idLocalidad: '' });
      onHide();
    } catch (err) {
      console.error('Error al crear derivador:', err);
      setError('Error al crear el derivador');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setFormData({ nombre: '', especialidad: '', idLocalidad: '' });
    setError('');
    onHide();
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Nuevo Especialista Derivador</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          {error && <div className="alert alert-danger">{error}</div>}
          
          <Row>
            <Col xs={12}>
              <Form.Group className="mb-3">
                <Form.Label>Nombre *</Form.Label>
                <Form.Control
                  type="text"
                  value={formData.nombre}
                  onChange={(e) => setFormData(prev => ({ ...prev, nombre: e.target.value }))}
                  placeholder="Nombre del especialista..."
                  required
                  autoFocus
                />
              </Form.Group>
            </Col>
            <Col xs={12}>
              <Form.Group className="mb-3">
                <Form.Label>Especialidad</Form.Label>
                <Form.Control
                  type="text"
                  value={formData.especialidad}
                  onChange={(e) => setFormData(prev => ({ ...prev, especialidad: e.target.value }))}
                  placeholder="Especialidad..."
                />
              </Form.Group>
            </Col>
            <Col xs={12}>
              <Form.Group className="mb-3">
                <Form.Label>Localidad</Form.Label>
                <Form.Select
                  value={formData.idLocalidad}
                  onChange={(e) => setFormData(prev => ({ ...prev, idLocalidad: e.target.value }))}
                >
                  <option value="">Seleccione...</option>
                  {localidades.map((loc) => (
                    <option key={loc.idLocalidad} value={loc.idLocalidad}>
                      {loc.localidad}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose} disabled={loading}>
            Cancelar
          </Button>
          <Button variant="primary" type="submit" disabled={loading}>
            {loading ? 'Guardando...' : 'Guardar'}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default NuevoDerivadorModal;
